import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'

export interface AmpDatamapperProps {
    link: string
}

export const isAmpDatamapper = (link: string) => {
    return link.indexOf('https://datawrapper.dwcdn.net/') >= 0
}

export const AmpDatamapper: React.FC<AmpDatamapperProps> = (props) => (
    <AmpIFrame
        width={797} // Set to create an Aspect ratio, the layout = responsive will resize
        height={500} // Set to create an Aspect ratio, the layout = responsive will resize
        src={props.link}
        frameborder={0}
        layout={'responsive'}
        allowSameOrigin={true}
        allowPopups={true}
        allowForms={false}
        resizable={true}
        noFallback={true}
    >
        <div overflow tabIndex={0} role="button" aria-label="View more">
            View more
        </div>
    </AmpIFrame>
)
